import { useRef } from "react";

import { FormInstance } from "antd";
import InterfaceComponent from "./Masters/InterfaceComponent";

export default function AuditReporting() {
  const formRef = useRef<FormInstance>(null);
  return (
    
      <InterfaceComponent
        InterfaceName={"Audit Reporting"}
        DashboardName={null}
        ref={formRef}
      />
    
  );
}
